import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { useFormatDate } from '@/shared/lib'

export const useRefundTerm = () => {
  const t = useTranslations('refund_policy')

  const { formatDate } = useFormatDate()

  const getDiffDayText = (toDateDiffDays: number | null) => {
    return t('rule', { days: toDateDiffDays ?? 0 })
  }

  const getDiffDateText = (fromDate: string | null, toDate: string | null) => {
    if (isNull(toDate)) {
      return t('date.after_move_in', {
        date: formatDate({ date: fromDate!, format: 'yyyy. MM. dd' }),
      })
    }

    return t('date.before_move_in', {
      date: formatDate({ date: toDate, format: 'yyyy. MM. dd' }),
    })
  }

  const getPenaltyText = (
    penalty: number | null,
    isOldRefundTerms: boolean,
  ) => {
    if (penalty === 0) {
      return t('result.free_cancel')
    }

    if (isNull(penalty)) {
      return t('result.not_allowed')
    }

    if (isOldRefundTerms) {
      return `임대료의 ${penalty}%`
    }

    return t('result.percent', { penalty })
  }

  return {
    getDiffDayText,
    getDiffDateText,
    getPenaltyText,
  }
}
